export default __webpack_public_path__ + "static/andy-logo-2-fc8b67cdb5f05c2a7088f72a094b72c4.png";